import { ShoppingCartOutlined } from "@ant-design/icons"
import { Badge, Col, Divider, Row, Tabs, Typography } from "antd"
import React, { useEffect, useState } from "react"
import ActiveTable from "../../../components/PaperManager/Orders/Tables/ActiveTable"
import StoppedOrders from "../../../components/PaperManager/Orders/Tables/StoppedOrders"
import MachineDoneList from "../../../components/Orders/Machines/MachineDoneList"
import MachinesOrderTable from "../../../components/PaperManager/Orders/Tables/MachinesOrderTable"
import { collection, onSnapshot, query, where } from "firebase/firestore"
import { db } from "../../../firebase/config"
import DoneOrdersList from "./DoneOrdersList"
import { addProjectedMeters } from "../../../components/utils/ProjectedMeters/ProjectedMeters"
import UpcomingDesignerOrders from "../../../components/PaperManager/Orders/Tables/UpcomingDesignerOrders"
import useFetchUpcomingDesignerOrders from "../../../store/PaperManager/useFetchUpcomingDesignerOrders"
import DoneUnshippedList from "./DoneUnshipped"

const { Paragraph, Title } = Typography

export default function OrdersPaperManager() {
  const {
    designerOrders,
    loading: designerLoading,
    designerOrdersCount,
  } = useFetchUpcomingDesignerOrders()

  const [activeKey, setActiveKey] = useState(1)
  const [tablesLoading, setTablesLoading] = useState(false)
  const [tableData, setTableData] = useState([])

  //fetch data for all machines
  useEffect(() => {
    setTablesLoading(true)
    const ref = collection(db, "orders")
    let q = query(ref, where("orderStatus", "in", [3, 4, 5]))

    const unsubscribe = onSnapshot(q, async (snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        const data = doc.data()
        results.push({ ...data, key: doc.id, id: doc.id })
      })

      const withMeters = await addProjectedMeters(results)

      setTableData(withMeters)
      setTablesLoading(false)
    })

    return () => unsubscribe()
  }, [])

  const items = [
    {
      key: 1,
      label: `Active`,
      children: <ActiveTable />,
    },
    // {
    //   key: 2,
    //   label: `Arsoma`,
    //   children: (
    //     <MachinesOrderTable activeKey={activeKey} tableData={tableData} loading={tablesLoading} />
    //   ),
    // },
    // {
    //   key: 3,
    //   label: `Viva`,
    //   children: (
    //     <MachinesOrderTable activeKey={activeKey} tableData={tableData} loading={tablesLoading} />
    //   ),
    // },
    // {
    //   key: 4,
    //   label: `Winder`,
    //   children: (
    //     <MachinesOrderTable activeKey={activeKey} tableData={tableData} loading={tablesLoading} />
    //   ),
    // },
    {
      key: 8,
      label: (
        <Badge count={designerLoading ? 0 : designerOrdersCount} offset={[5, 0]} showZero={false}>
          Upcoming (Designer Orders)
        </Badge>
      ),
      children: <UpcomingDesignerOrders orders={designerOrders} ordersLoading={designerLoading} />,
    },
    {
      key: 5,
      label: `Warehouse Orders (Printing)`,
      children: <MachineDoneList />,
    },
    {
      key: "Tape",
      label: `Warehouse Orders (Tape)`,
      children: <MachineDoneList doneForMachine="Tape" />,
    },
    {
      key: "Done",
      label: `Done (no document)`,
      children: <DoneUnshippedList />,
    },
    {
      key: 6,
      label: `Shipped (with document)`,
      children: <DoneOrdersList />,
    },

    {
      key: 7,
      label: `Stopped`,
      children: <StoppedOrders activeKey={activeKey} />,
    },
  ]

  const handleTabChange = (key) => {
    setActiveKey(key)
  }

  return (
    <div style={{ padding: 15 }}>
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <Title level={3}>
            <ShoppingCartOutlined />
            <Divider type="vertical" />
            My Orders
          </Title>
        </Col>
        <Col span={24}>
          <Paragraph type="secondary">
            This is a orders section. Here you can view and filter all kinds of orders. Everything
            that is created/edited are being displayed here.
          </Paragraph>
        </Col>
      </Row>

      <Tabs defaultActiveKey={1} onChange={handleTabChange} items={items} />
    </div>
  )
}
